module.exports = __webpack_public_path__ + "static/media/cit.7c20c1f2.png";